import { useState } from "react";
import "./App.css";
import { customStyles, customTheme } from "./styles";
import AsyncSelect from "react-select/async";
import { components } from "react-select";
import { citiesObject, filterCities } from "./cities-service";
import "../node_modules/flag-icon-css/css/flag-icons.min.css";
import CityItem from "./components/CityItem";
import WorkingHours from "./components/legend/WorkingHours";
import NonWorkingHours from "./components/legend/NonWorkingHours";
import SleepingHours from "./components/legend/SleepingHours";
import InputMinValue, {
  getBeginningOfDayTimestamp,
} from "./components/InputMinValue";
import InputMaxValue, {
  getEndOfDayTimestamp,
} from "./components/InputMaxValue";
import CircularSlider from "@fseehawer/react-circular-slider";
import {
  CircularInput,
  CircularProgress,
  CircularThumb,
  CircularTrack,
} from "react-circular-input";
const filterOptions = (inputValue) => {
  const filteredCities = filterCities(inputValue).map((city) => {
    return {
      value: city.city,
      label: city.city,
      country: city.country,
      timezone: city.timezone,
      flag: city.flag,
    };
  });
  return filteredCities;
};
const Option = (props) => {
  const cityData = citiesObject[props.label];
  if (!cityData) {
    return null;
  }

  return (
    <div content={"Customise your option component!"}>
      <components.Option {...props}>
        <div className="option-city-heading">
          <span>{props.label}</span>
          <span className={cityData.flag}></span>
        </div>
        <div className="option-city-country">
          <span>
            {cityData.country} [{cityData.timezone}]
          </span>
        </div>
      </components.Option>
    </div>
  );
};

function App() {
  const [selectedCity, setSelectedCity] = useState("");
  const [citiesArr, setCitiesArr] = useState([]);
  const [time, setTime] = useState(new Date().getTime());
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState(0);
  const [isDragging, setIsDragging] = useState(true);

  const tooltipStyle = {
    display: tooltipVisible ? "block" : "none",
    left: tooltipPosition + "px",
  };

  const loadCities = (inputValue, cb) => {
    if (inputValue.length > 2) {
      setTimeout(() => {
        cb(filterOptions(inputValue));
      }, 0);
    }
  };

  const addCityHandler = (city) => {
    setCitiesArr((prev) => [...new Set([...prev, city])]);
  };
  const handleMouseOut = () => {
    setTooltipVisible(false);
  };

  const selectChangeHandler = (value, action) => {
    if (value?.value && value.value !== "No cities") {
      console.log(value);
      setSelectedCity(null);
      addCityHandler(value);
    } else {
      setSelectedCity(null);
    }
  };
  const sliderChangeHandler = (event) => {
    setTooltipVisible(true);

    setTime(+event.target.value);
    const { min, max, offsetWidth } = event.target;
    const minVal = parseInt(min);
    const maxVal = parseInt(max);
    const position =
      ((event.target.value - minVal) / (maxVal - minVal)) * offsetWidth;
    setTooltipPosition(position);
  };

  const circleInputHandler = (value) => {
    let now = time;

    let newVal =
      +getBeginningOfDayTimestamp(time).getTime() +
      (+getEndOfDayTimestamp(time).getTime() -
        +getBeginningOfDayTimestamp(time).getTime()) *
        value;

    console.log(
      new Date(newVal).getTime() - +getBeginningOfDayTimestamp(time).getTime()
    );
    setTime(+new Date(newVal).getTime());
  };

  return (
    <>
      <nav class="navbar ">
        <div class="container-fluid">
          <span class="navbar-brand mb-0 h1">
            <img
              src="android-chrome-512x512.png"
              alt="Logo"
              width="24"
              height="24"
              class="d-inline-block align-text-top"
            />
            Time Zone Converter
          </span>
        </div>
      </nav>
      <div className="container-fluid mt-5">
        <div className="row mx-1 ">
          <div className="search-field-container px-xl-5 py-xl-4 py-4 px-3   my-5  col-12 offset-md-1 col-md-10 col-xl-6 offset-xl-3">
            <span className="search-field-title">What time is it?</span>
            <AsyncSelect
              className=" select-element"
              components={{ Option }}
              value={
                selectedCity
                  ? { label: selectedCity, value: selectedCity }
                  : null
              }
              onChange={selectChangeHandler}
              cacheOptions
              autoFocus={true}
              placeholder="Search for the city"
              noOptionsMessage={() => {
                return "Min 3 characters...";
              }}
              isClearable
              escapeClearsValue={true}
              loadOptions={loadCities}
              theme={customTheme}
              styles={customStyles}
            />
          </div>
        </div>
        <div className={`row ${citiesArr.length && "d-none"}`}>
          <p className="converter-description col-12 col-lg-6 offset-lg-3">
            <em>
              This handy tool allows you to easily find the time zone of any
              city around the world. Whether you're planning a trip, scheduling
              a global conference call, or simply curious about the current
              local time in a specific location, our time zone converter has got
              you covered.
            </em>
          </p>
          <p className="converter-description col-12 col-lg-6 offset-lg-3">
            <strong>
              Start by entering a city name in the search box above and our
              converter will provide you with the current local time for that
              city.
            </strong>
          </p>
        </div>

        <div className="row d-flex justify-content-center">
          <div className="col-xl-8 offset-xl-2 container">
            <div className="row d-flex justify-content-center">
              {citiesArr.map((city, index) => {
                return <CityItem city={city} key={index} time={time} />;
              })}
            </div>
          </div>
        </div>

        <div className={`row my-5 ${!citiesArr.length && "d-none"}`}>
          <div className="col-10 row-controls py-4 offset-1 col-md-10 offset-md-1">
            <div className="d-flex circular-input justify-content-center">
              <CircularInput
                width={100}
                height={100}
                value={
                  (time - +getBeginningOfDayTimestamp(time).getTime()) /
                  (+getEndOfDayTimestamp(time).getTime() -
                    +getBeginningOfDayTimestamp(time).getTime())
                }
                onChange={circleInputHandler}
              >
                <CircularTrack stroke="#d6e4e8" />
                <CircularProgress stroke="#497580" />
                <CircularThumb
                  aria-valuenow={0.2}
                  aria-valuetext="sada"
                  stroke="#88b1bb"
                  fill="#88b1bb"
                />
              </CircularInput>
            </div>
            <div className="col-12 buttons-container my-4 d-flex justify-content-center gap-2 ">
              <button
                onClick={() => {
                  setTime((prev) => prev - 86400000);
                }}
                className="btn btn-sm   py-1 px-2 back-button "
              >
                {"<<"}
              </button>
              <button
                onClick={() => {
                  setTime(+new Date().getTime());
                }}
                className="btn btn-sm  py-1 px-2 "
              >
                Current Time
              </button>
              <button
                onClick={() => {
                  setTime((prev) => prev + 86400000);
                }}
                className="btn btn-sm  py-1 px-2 forward-button"
              >
                {">>"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
